module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.4871/images/default-avatar.png"